import React from 'react';
import {Layout} from "antd";
import FormSearch from "./components/FormSearch";
import ListFileUpload from "./components/ListTrade";
const Content = Layout.Content;
class ListTradeContainer extends React.Component{
    render() {
        return (
            <Layout>
                <Content className="a-content--ant-layout">
                    <FormSearch/>
                    <ListFileUpload/>
                </Content>
            </Layout>
        );
    }
}
export default ListTradeContainer;